import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // English as default
    lng: 'en', // Default language
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'default',
      },
      allowMultiLoading: false,
      crossDomain: false,
    },

    ns: ['common', 'navigation', 'prints', 'about', 'services', 'blog', 'forms', 'printDescriptions', 'tools'],
    defaultNS: 'common',

    supportedLngs: ['es', 'en'],

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },

    // Add loading timeout and error handling
    load: 'languageOnly',
    cleanCode: true,
    
    // Preload languages to avoid loading issues
    preload: ['en', 'es'],
    
    // Handle missing translations gracefully
    saveMissing: false,
    updateMissing: false,
    
    // Improve performance
    cache: {
      enabled: true,
    },
  });

export default i18n;